import { render } from "./ModelLogs.vue?vue&type=template&id=44f46896"
import script from "./ModelLogs.vue?vue&type=script&lang=js"
export * from "./ModelLogs.vue?vue&type=script&lang=js"

import exportComponent from "/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__